import { ResponsiveButtonPrimary } from 'components/PositionList/styled'
import { Dots } from 'components/swap/styleds'
import styled from 'styled-components'

const StyledClaimActionButton = styled(ResponsiveButtonPrimary)`
  width: max-content;
  background-color: var(--color-kodiak-button-primary);
  border: 1px solid var(--color-kodiak-button-primary);
  color: white;

  &:hover {
    background-color: var(--color-kodiak-brand-secondary);
    border-color: var(--color-kodiak-brand-secondary);
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    font-size: 12px;
  `}
`

interface ClaimActionButtonProps {
  className?: string
  fullWidth?: boolean
  disabled?: boolean
  isClaiming?: boolean
  isClaimed?: boolean
  onClick: (event: React.MouseEvent) => void
}

export function ClaimActionButton({
  className,
  fullWidth,
  disabled,
  isClaiming,
  isClaimed,
  onClick,
}: ClaimActionButtonProps) {
  return (
    <StyledClaimActionButton
      className={className}
      style={fullWidth ? { width: '100%' } : undefined}
      disabled={disabled}
      onClick={onClick}
    >
      {isClaimed ? 'Claimed' : isClaiming ? <Dots>Claiming</Dots> : 'Claim Rewards'}
    </StyledClaimActionButton>
  )
}
